// Auth-guarded pathless layout. All admin screens (dashboard/campaigns/etc.)
// live under this route — beforeLoad redirects to /sign-in if the in-memory
// token is missing or expired, preserving the original path as ?return so the
// sign-in callback can land the user back where they were.

import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { Layout } from '../components/layout/Layout.js';
import { useAuthStore } from '../lib/auth-store.js';

export const Route = createFileRoute('/_authed')({
  beforeLoad: ({ location }) => {
    if (!useAuthStore.getState().isAuthenticated()) {
      throw redirect({ to: '/sign-in', search: { return: location.pathname } });
    }
  },
  component: () => (
    <Layout>
      <Outlet />
    </Layout>
  ),
});
